import { importWithReload } from '@/lib/lazyWithReload'

let demoPagePromise

export function prefetchDemoPage() {
  demoPagePromise ||= importWithReload(() => import('@/pages/DemoPage'))
  return demoPagePromise
}
